import { c as _c } from "react/compiler-runtime";
import { Button } from "@website/ui/button";
export function AgenciesButton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Button className="!mx-0 max-lg:!hidden" color="neutral" href="https://b2b.snapptrip.com/b2b-login" role="link" size="medium" target="_blank" variant="text" rel="nofollow">آژانس ها و شرکت ها</Button>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}